
export default function IncludedFeatures() {
  const features = [
    {
      icon: 'ri-file-text-line',
      title: 'Monthly magazine',
      description: 'Print-ready PDF and digital formats included.'
    },
    {
      icon: 'ri-article-line',
      title: 'Core content included',
      description: 'Professional articles, stories, and features.'
    },
    {
      icon: 'ri-edit-line',
      title: 'Simple local updates workflow',
      description: 'Easy form-based submission for your facility news.'
    },
    {
      icon: 'ri-send-plane-line',
      title: 'Basic distribution guidance',
      description: 'Clear instructions for print and digital distribution.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What's included
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Everything you need to engage your community.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="flex items-start space-x-4 p-6 rounded-xl bg-gray-50 border border-gray-100 hover:shadow-md hover:border-purple-100 hover:bg-white transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center flex-shrink-0 bg-gradient-to-br from-purple-100 to-red-100 rounded-xl shadow-sm">
                <i className={`${feature.icon} text-2xl text-purple-600`}></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
